import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DisplayMode } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { Sgke122aResponseSearchresultList } from 'sg-api';

@Component({
  selector: 'app-sgke120d-search-result',
  templateUrl: './sgke120d-search-result.component.html',
  styleUrl: './sgke120d-search-result.component.scss'
})
export class Sgke120dSearchResultComponent implements OnInit, OnDestroy {
  /** モード */
  @Input() mode: string;
  /** 検索結果リスト */
  @Input() searchresultList: Array<Sgke122aResponseSearchresultList>;
  /** 報告済過不足額（累計） */
  @Input() confirmzumiKafusokuRuikei: number;
  /** 表示用過不足額合計 */
  @Input() hyojiBalanceSum:number;

  /** 報告ボタン押下Emitter */
  @Output() onClickReportEmitter = new EventEmitter();
  /** 承認ボタン押下Emitter */
  @Output() onClickApprovalEmitter = new EventEmitter();
  /** 行ダブルクリックEmitter */
  @Output() onDblClickRowEmitter: EventEmitter<Sgke122aResponseSearchresultList> = new EventEmitter();

  /** ソート */
  @ViewChild('sort1', { static: true }) sort: MatSort;

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /** モード_登録 */
  public MODE_CREATE = DisplayMode.create;
  /** モード区分_承認 */
  public MODE_APPROVE = DisplayMode.approve;

  /** データソース */
  dataSource: MatTableDataSource<Sgke122aResponseSearchresultList>;
  /** 選択した行の情報 */
  selection: SelectionModel<Sgke122aResponseSearchresultList>;

  /**
   * コンストラクタ
   */
  constructor(
  ) {
  }

  /**
   * 初期処理
   * @memberof Sgke120dResultComponent
   */
  ngOnInit(): void {
    // 表データと、ソート/ページングを連携
    this.dataSource = new MatTableDataSource<Sgke122aResponseSearchresultList>(this.searchresultList);
    this.selection = new SelectionModel<Sgke122aResponseSearchresultList>(true, []);
  }

  /**
   * ViewInit後の呼び出し
   * @memberof Sgke120dResultComponent
   */
  ngAfterViewInit(): void {
    this.dataSource.sort ??= this.sort;
  }

  /**
   * 購読解除
   * @memberof Sgke120dResultComponent
   */
  ngOnDestroy(): void {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * テーブル表示カラム生成
   * @param {boolean} isFooter 
   * @returns {string[]}
   * @memberof Sgke120dResultComponent
   */
  displayedColumnsCol(isFooter: boolean): string[] {
    // ベースとする全カラム(順番込み)
    let columns = [
      'select',
      // 口座入金予定年月日
      'kouzaReceivemoneyyoteiYearmonthdate',
      // 入金形態
      'rcvmnyKeitai',
      // 口座入金機関
      'kouzaRcvmnyFclt',
      // 入金件数
      'rcvmnyNumber',
      // 入金予定額
      'rcvmnyPlannedamount',
      // 口座入金額
      'kouzaRcvmnyAmt',
      // 手数料額
      'feeAmt',
      // 過不足額
      'kafusokuAmt',
      // 報告年月日
      'reportYearmonthdate',
      // 承認年月日
      'apprvYearmonthdate',
    ];
    // フッターで結合する分のカラムを削除
    if (isFooter) {
      columns = columns.filter(col => !['rcvmnyKeitai'].includes(col));
    }
    return columns;
  }

  /**
   * 対象のチェックボックス変更時処理
   * @param {Sgke122aResponseSearchresultList} row
   * @memberof Sgke120dResultComponent
   */
  selectionToggle(row: Sgke122aResponseSearchresultList): void {
    this.selection.toggle(row);
  }

  /**
   * 報告ボタン押下時処理
   * @memberof Sgke120dResultComponent
   */
  onClickReport(): void {
    // 親コンポーネントに通知
    this.onClickReportEmitter.emit(this.selection.selected);
  }

  /**
   * 承認ボタン押下時処理
   * @memberof Sgke120dResultComponent
   */
  onClickApproval(): void {
    // 親コンポーネントに通知
    this.onClickApprovalEmitter.emit(this.selection.selected);
  }

  /**
   * 行ダブルクリック時処理
   * @param {Sgke122aResponseSearchresultList} row 対象行情報
   * @param {MouseEvent} event マウスイベント
   * @memberof Sgke120dResultComponent
   */
  onDblClickRow(row: Sgke122aResponseSearchresultList, event?: MouseEvent): void {
    this.onDblClickRowEmitter.emit(row);
    event?.stopPropagation();
  }

  /**
   * 行の背景色取得
   * @param {Sgke122aResponseSearchresultList} row 
   * @returns {string}
   */
  getBackgroudColor(row: Sgke122aResponseSearchresultList): string {
    // 過不足金が0以外の場合、背景を変更する。
    return row.kafusokuAmt != 0 ? 'yellow' : 'none';
  }

  /**
   * 登録ボタン非活性情報取得
   * @readonly
   * @type {boolean}
   * @memberof Sgke120dResultComponent
   */
  get disableRegist(): boolean {
    return this.selection.selected.length < 1;
  }

  /**
   * テーブル高さ最大値取得
   * @readonly
   * @type {string}
   * @memberof Sgke120dResultComponent
   */
  get maxHeight(): string {
    return 'calc(48px * 10 + 141px)';
  }

  /**
   * テーブル高さ最小値取得
   * @readonly
   * @type {string}
   * @memberof Sgke120dResultComponent
   */
  get minHeight(): string {
    let rowSize = this.dataSource.data.length < 10 ? this.dataSource.data.length : 10;
    return 'calc(48px * ' + rowSize + ' + 141px)';
  }

}
